export const Test = "TEST"
export const UPDATE_MESSAGE_COUNT='UPDATEMESSAGECOUNT';

export const SET_ACTIVE_MENU='SET_ACTIVE_MENU';
export const TOGGLE_3D='TOGGLE_3D';
export const UPDATE_LOADER='UPDATE_LOADER';
